module.exports = __webpack_public_path__ + "img/hifu_c4ambw_c_scale,w_200.634448e9.jpg";